import * as React from "react";

interface FileUploadCircleProps {
    className?: string;
    onClick?: () => void;
}

export function FileUploadCircle(props: FileUploadCircleProps) {
    return (
        <div {...props}>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                    fill="#D8D8D8"
                />
                <path
                    d="M21.1667 15.7812V11H13.875C13.3901 11 13 11.3762 13 11.8438V28.1562C13 28.6238 13.3901 29 13.875 29H26.125C26.6099 29 27 28.6238 27 28.1562V16.625H22.0417C21.5604 16.625 21.1667 16.2453 21.1667 15.7812ZM23.543 23.3754H21.1667V26.1879C21.1667 26.4986 20.9056 26.7504 20.5833 26.7504H19.4167C19.0944 26.7504 18.8333 26.4986 18.8333 26.1879V23.3754H16.457C15.9364 23.3754 15.6764 22.7675 16.0461 22.4135L19.5614 19.049C19.8039 18.8166 20.1954 18.8166 20.4379 19.049L23.9532 22.4135C24.3232 22.7675 24.0636 23.3754 23.543 23.3754ZM26.7448 14.6914L23.1755 11.2461C23.0115 11.0879 22.7891 11 22.5557 11H22.3333V15.5H27V15.2855C27 15.0641 26.9089 14.8496 26.7448 14.6914Z"
                    fill="#818181"
                />
            </svg>
        </div>
    );
}
